import React, { FC } from 'react';
import { Text, View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import { connect } from 'react-redux';
import { MACHINES_PAGES_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';
import { ImagesDocumentsContent } from '@v2/pages/nc-file/details/modules/nc-file/components/ImagesDocumentsContent';
import { DOCUMENT_ENTITY_TYPE } from '@components/imageHandling/common';
import { useBackgroundColor } from '@v2/pages/machines/hooks/useBackgroundColor';

interface NCFileDocumentsProps extends NavigationProps {
  ncFileId: number | null;
}

const NCFileDocumentsComponent: FC<NCFileDocumentsProps> = ({ lg, ncFileId }) => {
  const { machineScreenMainBg } = useBackgroundColor();

  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false}
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      {ncFileId != null && (
        <View style={[MACHINES_PAGES_CONTAINER_STYLES, {paddingHorizontal: 0}]}>
          <ImagesDocumentsContent
            documentRetrieveId={ncFileId}
            documentRetrieveKey={DOCUMENT_ENTITY_TYPE.NcFile}
            bigSliderBg={machineScreenMainBg}
            smallSliderBg={machineScreenMainBg}
          />
        </View>
      )}
    </MachinesProvider>
  );
};

const NCFileDocuments = connect(({ details: { ncFileId } }) => ({ ncFileId }), {})(NCFileDocumentsComponent);

export { NCFileDocuments };
